module.exports = __webpack_public_path__ + "static/media/icn-edit.438b0547.svg";